export default __webpack_public_path__ + "static/media/VoronoiVoyagerPromo.89cf8654.mp4";